export function AppVersion() {
  return process.env.VUE_APP_VERSION || "000";
}

export function ApiBaseUrl() {
  return process.env.VUE_APP_API_URL || "tick.cloud";
}

export function RtcBaseUrl() {
  return process.env.VUE_APP_API_RTC_URL || "tick.cloud";
}


enum URL {
  // apiBase = `https://api.tick.cloud/api`,
  // rtcBase = `https://api.tick.cloud/hubs/chatwidget`,
  fileDataUrl = `filedata`,
  uploadFile = `ChatWidgetWebhook/uploadfile`,
  getSettings = `ChatWidgetWebhook/cwsettings/get`,

  sendMessage = `ChatWidgetWebhook/send`,
  sendCallbackRequest = `ChatWidgetWebhook/replyoptioncallback`,
  getMessages = `ChatWidgetWebhook/messages`,

  sendBasicTicketEvent = 'ChatWidgetWebhook/events/add/basic'

}

export default URL;
